export const knowledgeMenu = [
  {
    "displayName": "Basic",
    "displayHeading": "Basic Knowledge",
    "value": "basic",
    "topics": [
      {
        "question": "How do you buy mutual funds? ",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/knowledge-centre-how-to-buy-funds.jpg",
            "alt": "Illustration showing four steps to buy mutual funds.",
            "description": "Step 1: Identify your investing profile. Step 2: Decide your financial goals. Step 3: Pick a mutual fund based on your investment objective, time horizon and risk appetite. Step 4: Complete the investment process."
          }
        ]
      },
      {
        "question": "Types of mutual funds ",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/mutual_type.jpg",
            "alt": "Illustration showing different types of mutual funds.",
            "description": "The image categorizes mutual funds into Equity Schemes, Debt Schemes, Hybrid Schemes, Solution Oriented Schemes and Other Schemes."
          },
          {
            "type": "list",
            "heading": "Equity Schemes",
            "content": "Equity mutual funds invest predominantly in equities. They usually deliver higher returns than debts funds but they also have a high element of risk. Equity funds can be further classified under largecap, midcap, smallcap, multicap, diversified, thematic and ELSS."
          },
          {
            "type": "list",
            "heading": "Debt Schemes",
            "content": "Debt mutual funds invest in corporate and government bonds, corporate debt securities and money market instruments. They are also known as Income Funds or Bond Funds. These funds are less riskier than equity funds, offer regular income and are recommended to investors who are risk averse."
          },
          {
            "type": "list",
            "heading": "Hybrid Schemes",
            "content": "These schemes invest in two or more asset categories so that the investor can benefit from both. These kind of funds help you get a balanced portfolio with a mix of equity and debt instruments. It aims for the potential growth of equities and also provides stability to your portfolio."
          },
          {
            "type": "list",
            "heading": "Solution Oriented Schemes",
            "content": "These funds are important for long-term goal planning, particularly for retirement planning and a children’s education with a minimum lock-in period of 5 years."
          },
          {
            "type": "list",
            "heading": "Other Schemes",
            "content": "Schemes under this category include Index Funds/ETFs which replicate a particular index or FoFs where the minimum investment in the underlying fund is 95% of total assets."
          }
        ]
      },
      {
        "question": "More on Debt Funds",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/banner_contact.png",
            "alt": ""
          },
          {
            "type": "text",
            "text": "Debt Funds comprise of Liquid Fund, Ultra Low Duration Funds, Ultra Short Duration Funds, Money Market Funds,Corporate Funds, Banking Funds & PSU Funds, Gilt Funds etc."
          },
          {
            "type": "text",
            "text": "They invest in government securities and bonds of corporates and financial institutions and are also known as Income Funds"
          },
          {
            "type": "text",
            "text": "Debt funds generate returns for investors through the interest they earn by lending money to the government, corporates and financial institutions through various bonds."
          },
          {
            "type": "list",
            "heading": "Features of Debt Funds"
          },
          {
            "type": "list",
            "content": "Mutual funds invest in bonds that are tradable"
          },
          {
            "type": "list",
            "content": "Prices of bonds can rise of fall depending on the interest rate fluctuations, similar to the stock markets."
          },
          {
            "type": "list",
            "content": "A mutual fund can make additional profit by selling bonds at a price higher than purchase price. But the reverse could also happen if prices fall"
          },
          {
            "type": "list",
            "content": "By and large, debt securities are not as volatile as equities and hence debt funds are relatively safer investments especially for the conservative investor."
          }
        ]
      },
      {
        "question": "Top 5 reasons to invest in equity mutual funds",
        "answer": [
         {
          "type": "img",
          "img": "assets/images/knowledge-centre-top-five-reasons.jpg",
          "alt": "Infographic showing the top five reasons to invest in equity mutual funds.",
          "description": "The infographic highlights five reasons to invest in equity mutual funds: 1. High growth potential – Equity mutual funds can deliver long-term growth and help beat market inflation despite short-term market volatility. 2. Diversified portfolio – Investments are spread across different sectors and categories, reducing concentration risk. 3. Save tax – ELSS (Equity Linked Savings Scheme) investments provide tax benefits with a lock-in period of three years. 4. Tax-free returns – Long-term capital gains up to the applicable limit are tax exempt when the investment is held for more than 12 months. 5. Active vs. Passive management – Investors can choose actively managed funds where fund managers select investments or passively managed funds that track a market index."
        }
        ]
      },
      {
        "question": "Balanced and solution-oriented Funds.What are these?",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/image_1.jpg",
            "alt": ""
          },
          {
            "type": "text",
            "text": "Balanced or hybrid funds essentially invest in a mix of two or more asset classes."
          },
          {
            "type": "text",
            "text": "For instance, a fund that invests in equity and bond in a pre-determined proportion is an example of a balanced fund. The bond component in such a fund creates an income stream and balances out the volatility of equities whereas the equity component increases the fund’s growth potential."
          },
          {
            "type": "text",
            "text": "The main objective of a Balanced Fund is to enjoy the benefit of diversification. Instead of taking a high risk with equity, the balanced fund helps you invest prudently with lower risk."
          },
          {
            "type": "text",
            "text": "A Systematic Investment Plan (SIP) is a facility offered by mutual funds to investors enabling them to invest a fixed amount in a mutual fund at regular intervals. The frequency of investment could be weekly, fortnightly, monthly or quarterly."
          },
          {
            "type": "text",
            "text": "This fund is ideal for investors who seek income, capital appreciation and safety."
          },
          {
            "type": "img",
            "img": "assets/images/image_2.jpg"
          }
        ]
      }
    ]
  },
  {
    "displayName": "Intermediate",
    "displayHeading": "Intermediate Knowledge",
    "value": "mediate",
    "topics": [
      {
        "question": "How to read a mutual fund offer document? ",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/how-to-read.jpg",
            "alt": ""
          },
          {
            "type": "text",
            "text": "A mutual fund offer document offers investors essential information regarding the scheme. An investor should study the same thoroughly before making an investment. Here are some of the main topics covered in an offer document."
          },
          {
            "type": "list",
            "heading": "Investment Objective",
            "content": "Usually the first topic in an offer document, this section describes the nature and goal of the fund – whether to earn regular income or capital appreciation – in a nutshell."
          },
          {
            "type": "list",
            "heading": "Fund Manager",
            "content": "The Fund Manager is basically responsible for building and managing the fund portfolio. He or she is normally assisted by a team of analysts and other support staff who ensure that the fund operates efficiently and as per its objectives. Knowing the Fund Manager in charge and his or her past performance can add more confidence to an investor’s decision-making process."
          },
          {
            "type": "list",
            "heading": "Past Performance",
            "content": "Studying the past returns and performance of a fund may help an investor evaluate the future performance of the fund. While a fund may have delivered high returns in the previous year, it is important to check its performance over a period of time."
          },
          {
            "type": "list",
            "heading": "Benchmark Comparisons",
            "content": "This section helps an investor compare the fund’s performance versus a benchmark index for a wider perspective and better understanding of the fund’s performance."
          },
          {
            "type": "list",
            "heading": "Risk factor",
            "content": "It is mandatory for every fund to include a Riskometer that depicts just how safe or risky the fund is. This helps investors make a choice that matches their appetite for risk whether it is very low, low, medium, high or very high."
          },
          {
            "type": "list",
            "heading": "Expense Ratio",
            "content": "The expense ratio is the annual fee that all funds charge their investors. It expresses the percentage of assets deducted each fiscal year for fund expenses, management fees, administrative fees, operating costs, and all other asset-based costs incurred by the fund. It is calculated by dividing the fund’s total expenses by its assets under management on a daily basis."
          }
        ]
      },
      {
        "question": "What is asset allocation? ",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/asset.jpg",
            "alt": "Infographic explaining asset allocation and the factors that influence it.",
            "description": "The infographic explains that an ideal investment portfolio is a combination of equities, fixed income and cash, which is known as asset allocation. It highlights three key factors that determine asset allocation: your financial situation, your appetite for risk and your age. It also advises investors to review their asset allocation periodically as their age, financial needs and risk appetite change."
          }
        ]
      },
      {
        "question": "Top things to consider when selecting a mutual fund",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/top-things-to-consider.jpg",
            "alt": "Banner image with the text 'Make the Right Choice' alongside financial documents and a calculator."
          },
          {
            "type": "list",
            "heading": "Goals",
            "content": "Knowing whether your goals are short-term (new bike or a vacation) or long-term (child’s wedding or retirement) enables you to pick a fund that can deliver within the required timeframe."
          },
          {
            "type": "list",
            "heading": "Diversification",
            "content": "Mutual funds offer investors an opportunity to invest in a range of assets: equity, bonds, cash or commodities like gold and precious metals. You could consider investing across a variety of stocks and sectors to reduce your risk as well as to increase your potential for rewards."
          },
          {
            "type": "list",
            "heading": "Past Performance",
            "content": "Although past performance of a fund is not an assurance of future performance, it nevertheless offers information about the fund’s capabilities, its consistency in delivering returns and the likelihood of a similar future performance."
          },
          {
            "type": "list",
            "heading": "Risk",
            "content": "Every fund offer document carries a ‘Riskometer’ that indicates what levels of risk a fund will take in order to achieve its objective. It’s important for an investor to consider whether he/she is willing to bear the risk and whether his/her current financial health, age and needs will permit that level of risk."
          },
          {
            "type": "list",
            "heading": "Diversification",
            "content": "Mutual funds offer investors an opportunity to invest in a range of assets: equity, bonds, cash or commodities like gold and precious metals. You could consider investing across a variety of stocks and sectors to reduce your risk as well as to increase your potential for rewards."
          },
          {
            "type": "list",
            "heading": "Fees and Expenses",
            "content": "All mutual funds charge investors a fee for managing the fund and other administrative expenses. This is expressed as the expense ratio in an offer document. The lower the fees charged by a mutual fund the higher the realized returns. Actively managed funds tend to charge a higher fee than passively managed funds (within the maximum fee directed by SEBI)."
          }
        ]
      },
      {
        "question": "Fixed Income and Fixed Deposits ",
        "answer": [
         {
          "type": "img",
          "img": "assets/images/kc-intermediate--FDorFI_info.jpg",
          "alt": "Infographic comparing fixed income investments and fixed deposits.",
          "description": "The infographic compares Fixed Income investments and Fixed Deposits across four factors: Safety, Liquidity, Returns and Taxation. Fixed Income investments generally offer higher returns but do not guarantee capital safety, provide redemption in two to three days with possible exit loads, and long-term capital gains taxation after 36 months with indexation benefits. Fixed Deposits provide greater capital safety, can usually be redeemed in one to two days with a possible penalty for early withdrawal, offer comparatively lower returns, and interest earned is taxed according to the investor's income tax slab."
        }
        ]
      },
      {
        "question": "What are large cap, mid cap and small cap funds?",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/kc-intermediate--what-are-large-mid-smallcap-funds.jpg",
            "alt": ""
          },
          {
            "type": "text",
            "text": "Market capitalization or market cap is calculated by multiplying the number of shares of a company by the current market price of one share. Thus, a company with one lakh shares outstanding, selling at Rs. 100 per share, would carry a Rs.100 lakh market cap."
          },
          {
            "type": "list",
            "heading": "Large caps",
            "content": "Large caps are described as the first 100 companies in terms of market capitalization. These are well established, stable companies with a steady performance and are usually recommended as a foundation for your investment portfolio."
          },
          {
            "type": "list",
            "heading": "Mid caps",
            "content": "Mid caps include companies from 101st till 250th in terms of market capitalization. These companies are larger and better established than small caps and hence could be less risky. Mid cap funds could be less vulnerable to market volatility and are generally recommended for investors who want superior returns without high risk."
          },
          {
            "type": "list",
            "heading": "Small caps",
            "content": "Small caps are those companies after the 250th company in terms of market capitalization. These companies are not as established or financially stable as largecap companies could have significant growth potential. Mutual funds that invest in smallcap companies are called smallcap funds and tend to be volatile and highly risky. These funds are usually recommended for investors who seek aggressive growth and have an appetite for risk."
          }
        ]
      }
    ]
  },
  {
    "displayName": "Professional",
    "displayHeading": "Professional Knowledge",
    "value": "professional",
    "topics": [
      {
        "question": "How to read a mutual fund offer document? ",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/SIP.jpg",
            "alt": ""
          },
          {
            "type": "text",
            "text": "A Systematic Investment Plan (SIP) is a facility offered by mutual funds to investors enabling them to invest a fixed amount in a mutual fund at regular intervals. The frequency of investment could be weekly, fortnightly, monthly or quarterly."
          },
          {
            "type": "list",
            "heading": "Easy on the wallet",
            "content": "You no longer need to wait till you have accumulated a huge lumpsum in order to start working towards your goals. Even if all you can save up monthly is just Rs. 500, you can still start an SIP and start saving up for your goals."
          },
          {
            "type": "list",
            "heading": "Averages out cost of investment",
            "content": "By investing through the year, an investor lands up purchasing units at different prices. This helps average out the cost of an investment and works out better than trying to time the market or investing a lumpsum amount at a time."
          },
          {
            "type": "list",
            "heading": "No need to time the market",
            "content": "In an ideal scenario an investor would be able to purchase stocks at a low price and sell high. But trying to time the market in this manner is not only time consuming it can also be futile as you many never land up investing at all. By investing regularly with an SIP you will land up buying units at various prices and ultimately average out the cost of your investment."
          },
          {
            "type": "list",
            "heading": "Benefit from power of compounding",
            "content": "An SIP is useful whether your investment horizon is short-term or long-term. A long-term investment horizon helps you benefit from the power of compounding. Hence it is important to start investing early."
          },
          {
            "type": "list",
            "heading": "Brings discipline to investing",
            "content": "In order to reach your goals, you need a well-planned investment strategy as well as discipline. The best part about an SIP is that it lets you attend to your other commitments while ensuring that you still stay on track towards reaching your financial goals."
          }
        ]
      },
      {
        "question": "What is rupee cost averaging? ",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/kc-advanced-what-is-rupee-cost-avg.jpg",
            "alt": ""
          },
          {
            "type": "text",
            "text": "As an investor, your goal is to buy stocks at the lowest price and sell at the highest. However you can never be certain that the price you are paying is the lowest as there are chances it could go lower in the future."
          },
          {
            "type": "text",
            "text": "Trying to time your investments such that you get the best price is called speculation and the fallout of this is that you may never land up investing since you are waiting for the right price to arrive. "
          },
          {
            "type": "text",
            "text": "Instead, by investing on a regular basis, throughout the year, investors can average out the cost of their investment. This is known as Rupee Cost Averaging and is the basis of the Systematic Investment Plan (SIP)."
          },
          {
            "type": "text",
            "text": "For illustration purposes, let’s assume Investor A invests 10,000 per month in a mutual fund using an SIP."
          },
          {
            "type": "text",
            "text": "As such the average cost per unit works out to 94.8 instead of Rs. 100. Investing via an SIP helps an investor get the best rate for their investments rather than trying to time the market. If Investor A had invested Rs. 50,000 in the first month itself in a lumpsum, the cost per unit would be Rs. 100 and he would have accumulated 500 units only."
          },
          {
            "type": "text",
            "text": "In the illustration above, the difference in the NAV across 5 months is small but over years, the price value will vary significantly and make a considerable difference to the average cost of your investment"
          },
          {
            "type": "text",
            "text": "Rupee-cost averaging is a long-term strategy and is a good strategy to overcome the need to speculate or time the market."
          }
        ]
      },
      {
        "question": "STP and SWP made simple",
        "answer": [
          {
            "type": "list",
            "heading": "STP",
            "content": "Systematic Transfer Plan or STP is a facility offered by mutual funds whereby an investor can transfer a certain amount from one fund to another at pre-determined amounts and intervals."
          },
          {
            "type": "list",
            "heading": "When should you opt for this facility?",
            "content": "Let’s assume you have just received a gift of Rs. 10 lakhs from a relative and you would like to invest this in equity. However since markets are volatile you are reluctant to invest the entire amount now. Hence you invest this sum in a liquid/short term fund and then systematically transfer smaller amounts to an equity fund over a period of time."
          },
          {
            "type": "text",
            "text": "This facility is ideal for investors who are reviewing their portfolio and considering systematic asset allocation. By investing a lumpsum in debt funds you are protecting your capital and by investing it in equity you are growing your capital."
          },
          {
            "type": "img",
            "img": "assets/images/kc-advanced-STP-SWP_2.jpg",
            "alt": ""
          },
          {
            "type": "list",
            "heading": "SWP",
            "content": "Systematic Withdrawal Plan or SWP is a facility offered by mutual funds whereby an investor can withdraw a fixed sum from their mutual fund at regular intervals. Investors can use this to redeem their mutual fund in small portions to meet short-term needs or for regular monthly income."
          },
          {
            "type": "list",
            "heading": "When should you opt for this facility?",
            "content": "Investors who receive a retirement bonus or a huge lumpsum can invest it in a mutual fund and then opt for this facility in order to meet their monthly expenses. This brings discipline to spending as well as helps you grow your capital."
          }
        ]
      },
      {
        "question": "The power of compounding",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/power-of-compounding.jpg",
            "alt": ""
          },
          {
            "type": "text",
            "text": "\"He, who understands the power of compounding, earns it and he who doesnt pays it\". – Albert Einstein"
          },
          {
            "type": "text",
            "text": "Compound interest is one of the most impressive principles of investing. As complicated as it may sound, it’s really simple mathematics at play."
          },
          {
            "type": "text",
            "text": "To illustrate how it works, let’s imagine you’ve started investing with a sum of Rs. 10,000 at 7% p.a. At the end of the year, you will earn an interest of Rs. 700. This is added to your capital creating a new principal amount of Rs. 10,700. In the next year 7% on Rs. 10,700 earns you an interest of Rs. 749."
          },
          {
            "type": "text",
            "text": "In other words, compounding interest is simply interest on the principal amount invested as well as on the accumulated returns of the previous periods. Over time, the interest earned becomes more significant as the principal amount grows larger."
          },
          {
            "type": "text",
            "text": "In order to benefit from the power of compounding, it’s important to start early. Starting early and staying invested for a longer horizon enables your money to grow over time. If you start investing later then you will need to invest much larger sums of money to reach your goals."
          }
        ]
      },
      {
        "question": "Tax benefits of investing in mutual funds",
        "answer": [
          {
            "type": "img",
            "img": "assets/images/Knowledge-Center-mutual.jpg",
            "alt": "Infographic explaining the tax benefits of investing in mutual funds.",
            "description": "The infographic explains the tax treatment of equity, hybrid and debt mutual funds based on the holding period. For equity and hybrid funds, gains held for less than one year are taxed at 15%, gains held for one to three years above the applicable exemption limit are taxed at 10%, and gains held for more than three years above the exemption limit are also taxed at 10%. For debt funds, gains are taxed according to the investor's income tax slab for holding periods of up to three years, while investments held for more than three years are taxed at 20% with indexation benefits. The infographic also explains that Equity Linked Savings Schemes (ELSS) have a three-year lock-in period and provide tax deduction benefits under the applicable provisions of the Income Tax Act."
          }
        ]
      }
    ]
  }
]
